if (!customElements.get('mobile-sticky-atc')) {
  customElements.define(
    'mobile-sticky-atc',
    class MobileStickyAtc extends HTMLElement {
      constructor() {
        super();
        this.mainSubmitId = this.dataset.mainSubmit;
        this.mainPriceId = this.dataset.mainPrice;
        this.formId = this.dataset.formId;
        this.stickyButton = this.querySelector('[data-sticky-submit]');
        this.stickyButtonText = this.querySelector('[data-sticky-submit-text]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
      }

      connectedCallback() {
        this.mainSubmit = document.getElementById(this.mainSubmitId);
        this.mainPrice = document.getElementById(this.mainPriceId);
        if (!this.mainSubmit) return;

        this.setupObserver();
        this.stickyButton.addEventListener('click', this.handleClick.bind(this));

        this.variantChangeUnsub = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.variantChangeUnsub?.();
      }

      setupObserver() {
        this.observer = new IntersectionObserver(
          ([entry]) => {
            const mainVisible = entry.isIntersecting;
            this.setAttribute('data-visible', mainVisible ? 'false' : 'true');
            this.setAttribute('aria-hidden', mainVisible ? 'true' : 'false');
          },
          { threshold: 0, rootMargin: '0px 0px -40px 0px' }
        );
        this.observer.observe(this.mainSubmit);
      }

      handleClick(event) {
        event.preventDefault();
        if (this.stickyButton.hasAttribute('disabled')) return;

        const mainBtn = document.getElementById(this.mainSubmitId);
        if (!mainBtn || mainBtn.hasAttribute('disabled')) return;

        mainBtn.click();
      }

      handleVariantChange() {
        requestAnimationFrame(() => this.syncFromMain());
      }

      syncFromMain() {
        const mainBtn = document.getElementById(this.mainSubmitId);
        const mainPriceEl = document.getElementById(this.mainPriceId);

        if (mainBtn) {
          const disabled = mainBtn.hasAttribute('disabled');
          this.stickyButton.toggleAttribute('disabled', disabled);
          const label = mainBtn.querySelector('span')?.textContent?.trim();
          if (label && this.stickyButtonText) {
            this.stickyButtonText.textContent = label;
          }
        }

        if (mainPriceEl && this.stickyPrice) {
          this.stickyPrice.innerHTML = mainPriceEl.innerHTML;
        }
      }
    }
  );
}
